fx.ns("models", class ProductBookPage extends  models.CreationElement {

	constructor(data)
	{
		super(data);

        if (fx.get("app") != "screenshot" && data.id)
            this._fixBackgrounds();
	}
	
    static defaultSliceTextHeight = 10;
    
    get isCover()
    {
        return this.typeid == 6;
    }

    get sliceWidth()
    {
        return this.creation.sliceWidth;
    }

    get sliceText()
    {
        if (this.isCover)
        {
                let elt;
                for (let i = 0; i < this.components.length; i++)
                {
                    let comp = this.components.getItemAt(i);

                    if (comp.content_type == "slice-text")
                    {
                        elt = comp;
                        break;
                    }
                }
            return elt;
        }
    }

    get isFirstPage()
    {
        return this.number == 1;
    }

    get isLastPage()
    {
        return this.number > 1 && this.hasbackcover;
    }

    addSliceText(coverWidth, coverHeight, theme, customcolors, silent, content, text_color, font_family, font_size)
    {
        let defaultHeight = 10; // measured on screen, TODO : find a dynamic way to calculate it

        let sliceText = new models.CreationElementContent({  creation_element_id : this.id, 
            content : content,
            content_type : "slice-text", 
            creation:"slice", 
            component_type:"text", 
            x : (coverWidth - defaultHeight) / 2,
            y : coverHeight - (defaultHeight/2),
            width : coverHeight - defaultHeight,
            height : defaultHeight,
            rotation : 270,
            align:"center",
            text_color : text_color ? text_color : (theme.slice_textcolor ? theme.slice_textcolor: this._getTextColor("slice", customcolors).toRgbString() ), // TODO : slice_textcolor ? this._getTextColor("slice", customcolors).toRgbString(),
            font_family : font_family ? font_family : (!isNaN(parseInt(theme.slice_fontfamily)) ? theme.slice_fontfamily: (this.creation.last_font_family ? this.creation.last_font_family : 1) ), //this.creation.last_font_family ? this.creation.last_font_family : 1,
            font_size : font_size ? font_size : 5
            });

        this.components.addItem( sliceText, undefined, undefined, silent );
        

        return sliceText;
    }

    label(side, separator)
    {
        separator = separator || " - ";

        if (side)
        {
            if (side == "left") 
            {
                if (this.isCover)
                    return fx.text("Couverture Dos");
                else
                if (this.hasbackcover)
                {
                    if (this.isFirstPage)
                        return "";
                    else
                        return fx.text("Page") + " " + (this.number - 1 ) * 2;
                }
                else
                    return fx.text("Page") + " " + ((this.number - 1 ) * 2);
            }
            else // right
            {
                if (this.isCover)
                    return fx.text("Couverture Face");
                else
                if (this.hasbackcover)
                {
                    if (this.isFirstPage)
                        return fx.text("Page") + " 1";
                    else
                        return "";
                }
                else
                    return fx.text("Page") + "  " + ((this.number - 1 ) * 2 + 1)
            }
        }
        else
        {
            if (this.isCover)
                return fx.text("Couverture");
            else
            if (this.hasbackcover)
            {
                if (this.isFirstPage)
                    return "1";
                else
                    return (this.number - 1 ) * 2;
            }
            else
                return ((this.number -1 ) * 2) + separator + ((this.number-1 ) * 2 + 1);

                
        }
    }


    addComponent(data, side, width, height, extraWidth, layout, keepDesign)
    {
        data.creation_element_id = this.id;
        // background is a special case :
        // - on cover : we have to deal with slice cases
        // - background cover can spread on both pages
        if (data.component_type == "background")
        {
            if (this.isCover)
            {
                if (!side || side == "center") // update both backgrounds
                {
                    let backgrounds = this.getBackgrounds();

                    for (let i = 0; i < backgrounds.length; i ++)
                    {
                        if (backgrounds[i].creation == "slice")
                            backgrounds[i].update({align: ""});
                        else
                            backgrounds[i].update({content : data.content, align: "", bgcolor : data.bgcolor});
                    }
                
                }
                else // left of right
                {
                    this.addBackgrounds(); // in case one background was not created

                    let background = this.getBackground(side);
                    let backgroundOpposite = this.getBackground(side == "left" ? "right" : "left");
                    let backgroundCenter = this.getBackground("slice");

                    let align = (data.content == backgroundOpposite.content) ? "" : "split";

                    if (background)
                        background.update({ content : data.content, bgcolor : data.bgcolor, align : align });
                    
                    if (backgroundOpposite)
                        backgroundOpposite.update({ align : align });
                    
                    if (backgroundCenter)
                        backgroundCenter.update({ align : align });
                }
            }
            else // Page
            {
                if (side)
                {
                    let background = this.getBackground(side);
                    if (background)
                        background.update({content : data.content, bgcolor : data.bgcolor});
                }
                else
                {
                    let backgrounds = this.getBackgrounds();
                    for (let i = 0; i < backgrounds.length; i ++)
                        backgrounds[i].update({content : data.content, bgcolor : data.bgcolor});
                }
            }
           
        }
        else // sticker / photo /shape / text / other
        {
            // For text, set position and check background color so we can set text color to opposite
            if (data.component_type == "text")
            {
                // Set side
                // by default, add to right on cover, on left to page is not backcover
                if (!side) 
                {
                    // TODO : make if more clever
                    // add text on side where there is no text
                    if (this.isCover)
                        side = "right";
                    else
                    if (this.hasbackcover)
                    {
                        if (this.isFirstPage)
                            side = "right";
                        else
                            side = "left";
                    }
                    else
                        side = "left";
                }

            

                // find text as same side, same content dropped (contentid)
                let texts = this.getTexts();
                let text;
                for(let i = 0; i < texts.length; i++)
                {
                    if (data.contentid && data.content == texts[i].content)
                    {
                        if ( (side == "left" && texts[i].x < width) || (side == "right" &&  texts[i].x >= width + extraWidth))
                        {
                            text = texts[i];
                            break;
                        }
                    }
                }

                if (text)
                    text.delete();
                
                if (!layout && data.x === undefined)
                {
                    data.x = (width - data.width)/2;
                    data.y = (height - data.height)/2;

                    if (side == "right")
                        data.x += width + extraWidth;
                }

                // Change text color depending on background color
                if (!layout && (side == "left" || side == "right"))
                {
                    let color = "#ffffff";
                    let background = this.getBackground( side );

                    // Temporary fix : case when some background is missing :(
                    if (!background)
                    {
                        this.addBackgrounds();
                        background = this.getBackground( side );
                    }
                    
                    color = (background.content ? background.text_color : background.bgcolor); // we store in text_color the average color of the background image
                    color = tinycolor(color);

                    if (color.toRgbString() == data.text_color)
                    {
                        if (color.isDark())
                            color.brighten(color.getBrightness() > 20 ? 40 : 90);
                        else
                            color.darken(color.getBrightness() > 240 ? 70 : 20);
                            
                        data.content = data.content.replace(/rgb\((\d+),\s(\d+),\s(\d+)\)/g, color.toRgbString());
                        data.text_color = color.toRgbString(); //"#ffffff";
                        
                    }
                }
                
                
            }
            else
            if (data.component_type == "photo" && data.x === undefined) // added without position, need to be centered
            {
                if (data.componentWidth > data.componentHeight)
                {
                    data.width = width * 0.75;
                    data.height = data.componentHeight * data.width / data.componentWidth;
                }
                else
                {
                    data.height = height * 0.75;
                    data.width = data.componentWidth * data.height / data.componentHeight;
                }
                
                data.x = (width - data.width) / 2 + (side == "right" ? (width + extraWidth) : 0);
                data.y = (height - data.height) / 2;

                delete(data.componentWidth);
                delete(data.componentHeight);

            }
            else
            {
                if (side == "left")
                {
                    if (data.x > width)
                        data.x -= width;
                }
            }

            data.id = Utils.newID();
            data.level = this.maxLevel + 1;

            let index = this.components.length;

            if (data.component_type == "photo" && keepDesign)
            {
                for (let i = 0; i < this.components.length; i++)
                {
                    if (this.components.getItemAt(i).component_type == "background")
                        index = i;
                }

            }

            let component = new models.CreationElementContent( data );
            component.level = index + 1;

            for (let i = index + 1; i < this.components.length; i++)
                this.components.getItemAt(i).level++;
            
            this.components.addItemAt( index + 1, component );
        }
    }

    addPhoto(photos, side, width, height, extraWidth, layout, keepDesign)
   {
        this.applyLayout(layout, width, height, extraWidth, side, [], keepDesign);
                
        let photosComponents = this.photosComponents;
        
        for (let i = 0; i < photosComponents.length; i++)
        {
            let bounding = fx.graphics.getBoundingRect(photosComponents[i], photosComponents[i].rotation);

            if (side == "left" && bounding.x >= width)
                continue;

            if (side == "right" && bounding.x < width)
                continue;

            let photo =  photos.shift();
            if (photo)
                photosComponents[i].content = photo.id;
        }
   }

   getPagination(side, textcolor, bgcolor, fontsize, fontfamily)
   {
       let pageNumber = (this.number - 1 ) * 2;

       if(side === "right")
           pageNumber ++;
       
       return {    creation_element_id : this.id, 
                    width: 13,
                    height: 13,
                    content_type : "pagination", // /!\ don't forget content_type /!\
                    content : pageNumber,
                    component_type: "pagination", 
                    align: "center",
                    text_color : textcolor,
                    bgcolor : bgcolor,
                    font_size : fontsize,
                    font_family : fontfamily,
                    side : side
                };
   }

   applyLayout( layout, width, height, extraWidth, side, photosContents, keepDesign)
   {
       extraWidth = extraWidth || 0;

       if (this._photoContents.side != side)
           this._cleanPhotoContent();

       this._photoContents = this._photoContents.filter(function(component) {
           return component.content != "";
       });
   

       this._photoContents.side = side;

       if (photosContents)
           this._photoContents.push(...photosContents);
       
       // 1 - Remove all component, except backgrounds
       let existingComponents = this.components.toArray();
       
       while (existingComponents.length > 0)
       {
           let component = existingComponents.pop();

           let bounding = fx.graphics.getBoundingRect(component, component.rotation);
           let valid;

           if (this.hasbackcover)
           {
               if (this.isFirstPage)
               {
                   side = "right";
                   valid = bounding.x + bounding.width > width;
               }
               else
               {
                   side = "left";
                   valid = bounding.x + bounding.width > 0;
               }
           }
           else
               valid = layout.doublepage || 
                       !side || 
                       side == "center" || 
                       (side == "left" && bounding.x /*+ bounding.width*/ < width) || 
                       (side == "right" && bounding.x >= width);

           if (!valid)
               continue;

           if (!photosContents && component.isPhoto && component.content != "" && this._photoContents.find({content : component.content}) == null )
               this._photoContents.unshift(component);

           if ( !component.isBackground ) // let's test also if need to delete all component, or only component from one side
           {
               if (!keepDesign || component.isPhoto || component.isSticker  || component.isShape)
                   component.delete();
           }
               
       }

       //  2 - add layout components
       if (layout.doublepage)
       {
           for (let i = 0; i < layout.components.length; i++)
           {
               let layoutComponent = layout.components.getItemAt( i ).JSON;
               
               // background case
               if (layoutComponent.component_type == "background")
               {
                   if (!layout.isBasic)
                   {
                       let background = this.getBackground(layoutComponent.creation);
                       if (background)
                           background.update({content : (layout.isBasic) ? background.content : layoutComponent.content, align : layoutComponent.align, creation : layoutComponent.creation, bgcolor : layoutComponent.bgcolor });
                   }
               }
               else
               {
                   if (layoutComponent.component_type == "photo")
                       layoutComponent.content = "";

                   // move all element around slice if cover
                   if (this.isCover)
                   {
                       /*if (layoutComponent.component_type != "background" && layoutComponent.x >= width)
                           layoutComponent.x = Number(layoutComponent.x) + extraWidth;

                       // TODO : handle case of double page picture
                       if (layoutComponent.x == 0 && layoutComponent.width == 2*width && side == "")
                           layoutComponent.width = layoutComponent.width + extraWidth;*/
                   }

                   layoutComponent.creation = layoutComponent.x < ((width - extraWidth)/2) ? "left" : "right"; // to avoid text focus on apply layout
                   
                   this.addComponent(layoutComponent, "", width, height, extraWidth, true);
               }
                   
           }

       }
       else
       {
           // on layout design for one page that we need to apply on both pages
           if (!side|| side == "center")
           {
               for (let i = 0; i < layout.components.length; i++)
               {
                   let layoutComponent = layout.components.getItemAt( i ).JSON;
                   
                   if (layoutComponent.component_type == "background")
                   {
                       if (!layout.isBasic)
                       {
                           if (this.hasbackcover)
                           {
                               let bg = this.getBackground( (this.isFirstPage) ? "right" : "left");
                               if (bg)
                                   bg.update({content : (layout.isBasic) ? bg.content : layoutComponent.content, bgcolor : layoutComponent.bgcolor });    
                           }
                           else
                           {
                               let bgLeft = this.getBackground("left");
                               if (bgLeft)
                                   bgLeft.update({content : (layout.isBasic) ? bgLeft.content : layoutComponent.content, bgcolor : layoutComponent.bgcolor });

                               let bgRight = this.getBackground("right");
                               if (bgRight)
                                   bgRight.update({content : (layout.isBasic) ? bgRight.content : layoutComponent.content, bgcolor : layoutComponent.bgcolor });
                           }
                       }
                   }
                   else
                   {
                       if (layoutComponent.component_type == "photo")
                           layoutComponent.content = "";

                       if (this.hasbackcover)
                       {
                           layoutComponent.creation = (this.isFirstPage) ? "right" : "left";
                           layoutComponent.x =  Number(layoutComponent.x) + ( (this.isFirstPage) ? (extraWidth + width) : 0); 
                           this.addComponent(layoutComponent, (this.isFirstPage) ? "right" : "left", width, height, extraWidth, true, keepDesign)
                       }
                       else
                       {
                           layoutComponent.creation = "left";
                           this.addComponent(layoutComponent, "left", width, height, extraWidth, true, keepDesign)

                           layoutComponent.x =  Number(layoutComponent.x) + (width - extraWidth)/2 + extraWidth; 
                           layoutComponent.creation = "right";
                           this.addComponent(layoutComponent, "right",width, height, extraWidth, true, keepDesign)
                       }
                   }
               }
           }
           else
           {
               // first, we update background
               //let layoutBackgrounds = layout.getBackgrounds();
               let layoutBackground = layout.getBackground();
               let background = this.getBackground(side);

               if (!layout.isBasic)
               {
                   if(background && layoutBackground)
                       background.update({content : layoutBackground.content, bgcolor : layoutBackground.bgcolor});
               }

               for (let i = 0; i < layout.components.length; i++)
               {
                   let layoutComponent = layout.components.getItemAt( i ).JSON;
                   
                   if (layoutComponent.component_type != "background")
                   {
                       if (layoutComponent.component_type == "photo")
                           layoutComponent.content = "";

                       layoutComponent.creation = side;
                       if ((side == "right" || !side))
                           layoutComponent.x =  Number(layoutComponent.x) + extraWidth + width; 

                       this.addComponent(layoutComponent, side, width, height, extraWidth, true, keepDesign);
                   }       
               }
           }
       }
      
       // ---> SET PHOTOS content
       // sort photoContent from left to right, and components from left to right
       // and then apply content

       let components = this.components.filter(function(component) {
           return component.isPhoto && !component.deleted;
       });

       /*components.sort(function(a, b) {
           let bounding1 = fx.graphics.getBoundingRect(a, a.rotation);
           let bounding2 = fx.graphics.getBoundingRect(b, b.rotation);
           return bounding1.x - bounding2.x;
       })*/


       // apply left photos to left page and right photo to right page 
       //if (layout.doublepage || side == "")
       //{
           let pageWidth = layout.double || !side ? (width + extraWidth) / 2 : width;

           let leftPhotos = this._photoContents.filter(function(a) {
               let bounding = fx.graphics.getBoundingRect(a, a.rotation);
               return bounding.x < pageWidth;
           });

           let leftComponents = components.filter(function(a) {
               let bounding = fx.graphics.getBoundingRect(a, a.rotation);
               return bounding.x < pageWidth;
           });


           let rightPhotos = this._photoContents.filter(function(a) {
               let bounding = fx.graphics.getBoundingRect(a, a.rotation);
               return bounding.x >= pageWidth;
           });

           let rightComponents = components.filter(function(a) {
               let bounding = fx.graphics.getBoundingRect(a, a.rotation);
               return bounding.x >= pageWidth;
           });

           // sort leftPhotos, rightPhotos, rightComponents, leftComponent by horizontal pics to Vertical ones
           leftPhotos = leftPhotos.sort((a, b) => a.width_inner / a.height_inner > b.width_inner / b.height_inner ? 1 : -1 );
           rightPhotos = rightPhotos.sort((a, b) => a.width_inner / a.height_inner > b.width_inner / b.height_inner ? 1 : -1 );
           leftComponents = leftComponents.sort((a, b) => a.width_inner / a.height_inner > b.width_inner / b.height_inner ? 1 : -1 );
           rightComponents = rightComponents.sort((a, b) => a.width_inner / a.height_inner > b.width_inner / b.height_inner ? 1 : -1 );
           
           if (layout.doublepage)
           {
               let index = 0;
               for( let i = 0; i < leftComponents.length && index < leftPhotos.length; i++)
               {
                   let photoContent = leftPhotos[index];

                   let tempId = Utils.temporaryId(photoContent.content);
                   leftComponents[i].content = tempId;// ? tempId : photoContent.content;
                   index++;
               } 

               if (index < leftPhotos.length)
                   rightPhotos.push(...leftPhotos.slice(index));
               
               index = 0;
               for( let i = 0; i < rightComponents.length && index < rightPhotos.length; i++)
               {
                   let photoContent = rightPhotos[index];

                   let tempId = Utils.temporaryId(photoContent.content);
                   rightComponents[i].content = tempId;// ? tempId : photoContent.content;
                   index++;
               } 
           }
           else
           {
              /* let index = 0;

               for( let i = 0; i < rightComponents.length && index < rightPhotos.length; i++)
               {
                   let photoContent = rightPhotos[index];

                   let tempId = Utils.temporaryId(photoContent.content);
                   rightComponents[i].content = tempId;// ? tempId : photoContent.content;
                   index++;
               } 

               if (index < rightPhotos.length)
                   leftPhotos.push(...rightPhotos.slice(index));
               
               index = 0;
               for( let i = 0; i < leftComponents.length && index < leftPhotos.length; i++)
                   {
                       let photoContent = leftPhotos[index];
   
                       let tempId = Utils.temporaryId(photoContent.content);
                       leftComponents[i].content = tempId;// ? tempId : photoContent.content;
                       index++;
                   } */

                       this._photoContents.sort(function(a, b) {
                           let bounding1 = fx.graphics.getBoundingRect(a, a.rotation);
                           let bounding2 = fx.graphics.getBoundingRect(b, b.rotation);
                           return bounding1.x - bounding2.x;
                       })
           
                       components.sort(function(a, b) {
                           let bounding1 = fx.graphics.getBoundingRect(a, a.rotation);
                           let bounding2 = fx.graphics.getBoundingRect(b, b.rotation);
                           return bounding1.x - bounding2.x;
                       })
           
                       let index = 0;
                       for( let i = 0; i < components.length && index < this._photoContents.length; i++)
                       {
                           let bounding = fx.graphics.getBoundingRect(components[i], components[i].rotation);
                           let valid = layout.doublepage || !side || side == "center" || (side == "left" && bounding.x + bounding.width <= width) || (side == "right" && bounding.x >= width);
                           let photoContent = this._photoContents[index];
           
                           let tempId = Utils.temporaryId(photoContent.content);
                           if (valid)
                           {
                               components[i].content = tempId ? tempId : photoContent.content;
                               index++;
                           }
                       }
   
           }

       //}
       /*else
       {
           this._photoContents.sort(function(a, b) {
               let bounding1 = fx.graphics.getBoundingRect(a, a.rotation);
               let bounding2 = fx.graphics.getBoundingRect(b, b.rotation);
               return bounding1.x - bounding2.x;
           })

           components.sort(function(a, b) {
               let bounding1 = fx.graphics.getBoundingRect(a, a.rotation);
               let bounding2 = fx.graphics.getBoundingRect(b, b.rotation);
               return bounding1.x - bounding2.x;
           })

           let index = 0;
           for( let i = 0; i < components.length && index < this._photoContents.length; i++)
           {
               let bounding = fx.graphics.getBoundingRect(components[i], components[i].rotation);
               let valid = layout.doublepage || side == "" || side == "center" || (side == "left" && bounding.x + bounding.width <= width) || (side == "right" && bounding.x >= width);
               let photoContent = this._photoContents[index];

               let tempId = Utils.temporaryId(photoContent.content);
               if (valid)
               {
                   components[i].content = tempId ? tempId : photoContent.content;
                   index++;
               }
           } 
       }*/

       // In case only single page layout is applied, we updated properly align 
       if (this.isCover && side != "")
       {
           let bg = this.getBackground(side);
           if (!bg)
           {
               this.addBackgrounds();
               bg = this.getBackground(side);
           }
               
           if (bg && bg.content != "")
           {
               let backgroundLeft = this.getBackground("left");
               let backgroundRight = this.getBackground("right");
               let backgroundCenter = this.getBackground("slice");
               let align = (backgroundLeft.content == backgroundRight.content) ? "" : "split";

               if (backgroundLeft)
                   backgroundLeft.align = align;

               if (backgroundRight)
                   backgroundRight.align = align;

               if (backgroundCenter)
                   backgroundCenter.align = align;
           }
       }

       //for (let i = 0; i < this.components.length; i++)
       //    this.components.getItemAt(i).level = i;

       this.delay(this._cleanPhotoContent, 30000);
   }

   extractLayout(side, pageWidth, extraWidth)
   {
       let layout = new models.ThemeLayout({});

       for (let i = 0; i < this.components.length; i++)
       {
           let component = this.components.getItemAt(i);
           let bounding = fx.graphics.getBoundingRect(component, component.rotation);
               
           if (!component.isBackground && (side == "left" && bounding.x < pageWidth) ||
               (side == "right" && (bounding.x >= pageWidth + extraWidth)) )
           {
               let json = component.JSON;
               delete(json.id);
               delete(json.creation_element_id);

               if (json.component_type == "photo")
                 json.content = "";

               if (side == "right")
                   json.x -= pageWidth;

               layout.components.addItem( new models.ThemeLayoutComponent( json ) );
           }

       }

       layout.update({ height : this.creation.pageHeight,
                       width : this.creation.pageWidth});

       return layout;
   }

   addBackgrounds()
   {
       let centerBG = this.getBackground("slice");
       let leftBG = this.getBackground("left");
       let rightBG = this.getBackground("right");
       let split = this.isCover && ((!leftBG && !rightBG) || (leftBG && rightBG && leftBG.content != rightBG.content));

       if (this.isCover && !centerBG)
           this.components.addItemAt(0,new models.CreationElementContent({creation_element_id : this.id, creation:"slice", component_type:"background", bgcolor : this.bgcolor, align: split ? "split" : ""}) );
       
       if (!leftBG)
           this.components.addItemAt(0,new models.CreationElementContent({creation_element_id : this.id, creation:"left", component_type:"background", bgcolor : this.bgcolorleft, align: split ? "split" : ""}));
       
       if (!rightBG)
           this.components.addItemAt(0,new models.CreationElementContent({creation_element_id : this.id, creation:"right", component_type:"background", bgcolor : this.bgcolorright, align: split ? "split" : ""}));
   }

   _fixBackgrounds()
   {
       let manual = this.getBackground("manual");
       if (manual)
       {
           let leftBG = this.getBackground("left");
           let rightBG = this.getBackground("right");
           if (!leftBG)
               manual.creation = "left";
           else
           if (!rightBG)
               manual.creation = "right";
       }

       this.addBackgrounds();
   }


   updateBackgroundColor(color, side, removeContent, noCover)
    {
        if(this.isCover && noCover)
            return;
        let bgLeft, bgRight, bgSlice;
        if (this.isCover)
        {
            if (!side) // full
            {
                bgLeft = this.getBackground("left");
                if (bgLeft)
                    bgLeft.update({content: removeContent ? "" : bgLeft.content, align:"split", bgcolor : color});

                bgRight = this.getBackground("right");
                if (bgRight)
                    bgRight.update({content: removeContent ? "" : bgRight.content, align:"split", bgcolor : color});

                bgSlice = this.getBackground("slice");

                if (bgSlice)
                    bgSlice.update({content: removeContent ? "" : bgSlice.content , align:"split", bgcolor : color});

            }
            else
            if ( side == "center") // slice
            {
                // if backgrounds, set align to split
                /*let backgrounds = this.getBackgrounds();
                for (let i = 0; i < backgrounds.length; i++)
                    backgrounds[i].align = "split";

                this.bgcolor = color;*/

                //this.getBackground("slice").color = color;
                this.bgcolor = color;

                bgSlice = this.getBackground("slice");
                if (bgSlice)
                    bgSlice.update({align:"split", bgcolor : color});

                bgLeft = this.getBackground("left");
                if (bgLeft)
                    bgLeft.update({align:"split"});

                bgRight = this.getBackground("right");
                if (bgRight)
                    bgRight.update({align:"split"});
            }
            else
            {
                let background = this.getBackground(side);
                let backgroundOpposite = this.getBackground(side == "left" ? "right" : "left");
                let backgroundCenter = this.getBackground("slice");
                let align = "split";

                if (background)
                    background.update({content: removeContent ? "" : background.content , align:align, bgcolor : color});
                
                if (backgroundOpposite)
                    backgroundOpposite.update({align:align});
                
                if (backgroundCenter)
                    backgroundCenter.update({align:align});
                
                if (side == "left")
                    this.bgcolorleft = color;
                else
                    this.bgcolorright = color;
            }
        }
        else // Page
        {
            if (side)
            {
                let background = this.getBackground(side);
                if (background)
                    background.update({content: removeContent ? "" : background.content, bgcolor : color});

                if (side == "left")
                    this.bgcolorleft = color;
                else
                    this.bgcolorright = color;
            }
            else // both sides
            {
                bgLeft = this.getBackground("left");
                bgRight = this.getBackground("right");

                if (bgLeft)
                    bgLeft.update({content: removeContent ? "" : bgLeft.content, bgcolor : color});
                
                if (bgRight)
                    bgRight.update({content: removeContent ? "" : bgRight.content, bgcolor : color});

                this.update({bgcolorright : color, bgcolorleft : color});
            }
        }
    }
  
    updateLevels(component, down)
    {
        // in cas slice text is not on top
        if (this.sliceText)
            if (this.sliceText.level < this.components.length - 1)
                this.components.moveItem(this.sliceText, this.components.length - 1);
        
        if (down)
            this.components.moveItem(component, this.getBackgrounds().length);
        else
            this.components.moveItem(component, this.components.length - (this.sliceText ? 2 : 1)); // slice text always on top

        for (let i = 0; i < this.components.length; i++)
            this.components.getItemAt(i).level = i;
    }


    getComponents(side, width, extraWidth)
    {
        extraWidth = extraWidth || 0;
        let components = [];
        for(let i = 0; i < this.components.length; i++)
        {
            let component = this.components.getItemAt( i );
            
            let boundingRect = fx.graphics.getBoundingRect(component, component.rotation);

            if (side == "left")
            {
                if ((component.isBackground && component.creation == "left") || 
                    (!component.isBackground && boundingRect.x < width))
                {
                    components.push( component );
                }
                    
            }
            else
            {
                if ((component.isBackground && component.creation == "right") || 
                    (!component.isBackground && boundingRect.x + boundingRect.width > (width + extraWidth) ))
                {
                    components.push( component );
                }
                    
            }
        }

        return components.sort(function(a, b){ return (a.x < b.x) ? (side == "left" ? -1 : 1) : ((a.x > b.x) ? (side == "left" ? 1 : -1) : 0); });
        
    }

    _getTextColor(side, customcolors)
    {
        let lastColor = customcolors ? customcolors.lastColor : "#000";
        let color;
        let background = this.getBackground( side );
        if (background)
        {
            color = background.bgcolor;

            if (background.content)
            {
                let bg = fx.get("model").backgrounds.find({id : background.content});
                if (bg)
                    color = tinycolor(background.bgcolor);
            }

            color = tinycolor(color);

            // if background color is same as lastColor, let's darken or brithen it
            if (color.toRgbString() == lastColor)
            {
                if (color.isDark())
                    color.brighten(color.getBrightness() > 20 ? 40 : 90);
                else
                    color.darken(color.getBrightness() > 240 ? 70 : 20);
            }
            else
                color = tinycolor(lastColor);
        }
        else
            color = tinycolor(lastColor);
        

        return color;
    }

    componentsSort(a, b) 
    {  
        if (a.content_type == "slice-text")
            return 1;
        else
        if (b.content_type == "slice-text")
            return -1;

        if (a.isBackground && !b.isBackground)
            return -1;

        if (!a.isBackground && b.isBackground)
            return 1;

        if (a.isBackground && b.isBackground)
        {
            if (a.creation == "slice")
                return 1;
            else
            if (b.creation == "slice")
                return -1;
            else
                return 0;
        }

        if (a.isSliceText)
        {
            if (b.isBackground)
                return 1;
            else
                return -1;
        }

        if (a.level < b.level)
            return -1;

        if (a.level > b.level)
            return 1;

        return 0;
    }

    // apply a background on both sides of pages
    applyBackground(background)
    {
        let backgrounds = this.getBackgrounds();
        for (let i = 0; i < backgrounds.length; i ++)
            backgrounds[i].update({align: "", content : background.content, bgcolor : background.bgcolor});
    }

});
